// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__TjEs1","buttons":"RemoveExpirationActionButtons_buttons__2Pgx9"};